import React from 'react';
import { theme } from '@fiverr-private/theme';
import { L1_ICON_SIZES } from '../../constants';
import type { L1IconType } from '../../types';

const HourlyL1Icon = ({ size = 'sm', color = 'currentColor' }: L1IconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={L1_ICON_SIZES[size]}
    height={L1_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 21 24"
  >
    <path
      fillRule="evenodd"
      d="M7.4 1a.75.75 0 0 1 .75-.75h4.4a.75.75 0 0 1 0 1.5H11.1v1.827c5.228.384 9.35 4.747 9.35 10.073 0 5.578-4.522 10.1-10.1 10.1S.25 19.228.25 13.65c0-5.326 4.122-9.689 9.35-10.073V1.75H8.15A.75.75 0 0 1 7.4 1M3.368 2.77a.75.75 0 0 1 0 1.062l-1.65 1.65A.75.75 0 0 1 .658 4.42l1.65-1.65a.75.75 0 0 1 1.06 0m13.964 0a.75.75 0 0 1 1.06 0l.825.826.825.825a.75.75 0 1 1-1.06 1.06l-1.65-1.65a.75.75 0 0 1 0-1.06M10.35 5.05a8.6 8.6 0 1 0 0 17.2 8.6 8.6 0 0 0 0-17.2m0 3.45a.75.75 0 0 1 .75.75v3.975l2.386 1.432a.75.75 0 1 1-.772 1.286l-2.75-1.65a.75.75 0 0 1-.364-.643v-4.4a.75.75 0 0 1 .75-.75"
      clipRule="evenodd"
    />
  </svg>
);
HourlyL1Icon.displayName = 'HourlyL1Icon';
export default HourlyL1Icon;
